// extracted by mini-css-extract-plugin
module.exports = {"menuWrapper":"menuWrapper_menuWrapper__2MfF5"};